/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState, useReducer } from "react";
import {
  Routes,
  Route,
  NavLink,
  Navigate,
  useNavigate,
  useLocation,
} from 'react-router-dom';

import { MM } from "../engine/model_manager";

import { model_simulator } from "../engine/simulator";



const AuthContext = React.createContext(null);
const AuthDispatchContext = React.createContext(null);




function createInitialState() {
  console.log('createInitialState');

  let local_data = getLocalData();

  if (local_data.currentModel.model !== null) {
    var sim_res = model_simulator.runSimulation(local_data.currentModel.simEnvironment, local_data.currentModel.model, false);
    local_data.simResults = sim_res;
    local_data.baseline = makeBaseline(sim_res)
  }

  return local_data;
}


const AuthProvider = ({ children }) => {
  console.log('authprovider - begin');
  const [userEnvironment, dispatch] = useReducer(envReducer, createInitialState());


  console.log('  authprovider - pre return');
  return (
    <AuthContext.Provider value={userEnvironment}>
      <AuthDispatchContext.Provider value={dispatch}>
        {children}
      </AuthDispatchContext.Provider>
    </AuthContext.Provider>
  );
};


const useAuth = () => {
  return React.useContext(AuthContext);
};

const useDispatcher = () => {
  return React.useContext(AuthDispatchContext);
};


function makeBaseline(res) {
  let obj = {
    grandTotal: { ...res.timeSpan.grandTotal },
  }

  return obj;
}


function envReducer(env, action) {
  const NONE = 0;
  const MODEL = 1;
  const ENV = 2;
  let action_type = NONE;


  let obj = {
    userSettings: env.userSettings,
    session: env.session,
    currentModel: env.currentModel,
    simResults: env.simResults,
    baseline: env.baseline
  }


  switch (action.type) {
    case 'login': {
      obj.session = action.session;
      action_type = NONE;
    }
      break;
    case 'logout': {
      obj.session = null;
      action_type = NONE;
    }
      break;

    case 'loadModel': { // load from server
      obj.currentModel = {
        model: { ...action.body },
        simEnvironment: { ...env.currentModel.simEnvironment },
        lastSavedDate: action.lastSavedDate,
        lastUpdateDate: action.lastSavedDate
      }
      action_type = MODEL;
    }
      break;
    case 'updateModel': { // updated from client
      obj.currentModel = { model: { ...action.body }, lastSavedDate: action.lastSavedDate, lastUpdateDate: new Date().toJSON() }
      action_type = MODEL;
    }
      break;

    case 'addMilestone': {
      MM.addMilestone(obj.currentModel.model, action.milestone);
      action_type = MODEL;
    }
      break;
    case 'updateMilestone': {
      MM.updateMilestone(obj.currentModel.model, action.milestone);
      action_type = MODEL;
    }
      break;
    case 'deleteMilestone': {
      MM.deleteMilestone(obj.currentModel.model, action.id);
      action_type = MODEL;
    }
      break;

    case 'addAccount': {
      MM.addAccount(obj.currentModel.model, action.acct);
      action_type = MODEL;
    }
      break;
    case 'updateAccount': {
      MM.updateAccount(obj.currentModel.model, action.acct);
      action_type = MODEL;
    }
      break;

    case 'addItem': {
      MM.addItem(obj.currentModel.model, action.item);
      action_type = MODEL;
    }
      break;
    case 'updateItem': {
      MM.updateItem(obj.currentModel.model, action.item);
      action_type = MODEL;
    }
      break;
    case 'deleteItem': {
      MM.deleteItem(obj.currentModel.model, action.id);
      action_type = MODEL;
    }
      break;

    case 'enableParamControls': {
      createParameterControls(obj);
      action_type = ENV;
    }
      break;
    case 'disableParamControls': {
      obj.currentModel.simEnvironment.paramControls = [];
      action_type = ENV;
    }
      break;
    case 'updateParamControl': {
      obj.currentModel.simEnvironment = {
        ...env.currentModel.simEnvironment, paramControls: env.currentModel.simEnvironment.paramControls.map(

          //      env.currentModel.simEnvironment.paramControls = env.currentModel.simEnvironment.paramControls.map( 
          c => c.id !== action.id ? c : { ...c, value: action.value })
      };
      action_type = ENV;
    }
      break;

    // At the moment, only controls are %amt based controls
    case 'addQuickControl': {
      const item = action.item;

      let ctrl = {
        id: item.baseID,
        item: item,

        active: item.active,
        value: 100
      }
      obj.currentModel.simEnvironment.quickControls.push(ctrl);

      action_type = ENV;
    }
      break;
    case 'deleteQuickControl': {
      let qc = obj.currentModel.simEnvironment.quickControls;
      qc = qc.filter(c => c.id !== action.id);
      obj.currentModel.simEnvironment.quickControls = qc;

      action_type = ENV;
    }
      break;
    case 'updateQuickControl': {
      console.log(JSON.stringify(action));

      let qc = obj.currentModel.simEnvironment.quickControls;
      qc = qc.map(c => c.id !== action.id ? c : { ...c, active: action.active, value: action.value });
      obj.currentModel.simEnvironment.quickControls = qc;

      action_type = ENV;
    }
      break;

  }



  if (action_type !== NONE) {
    let is_scenario = action_type === ENV;

    const cm = obj.currentModel;
    const sim_res = model_simulator.runSimulation(cm.simEnvironment, cm.model, is_scenario);
    obj.simResults = sim_res;

    if (!is_scenario) {
      obj.baseline = makeBaseline(sim_res)
    }
  }


  let ld = {
    userSettings: obj.userSettings,
    session: obj.session,
    currentModel: obj.currentModel
  }

  setLocalData(ld);

  return obj;
}


function createParameterControls(env) {

  function createControl(id, value, min, max) {
    let obj = {
      id,
      value,
      min,
      max
    }

    env.currentModel.simEnvironment.paramControls.push(obj);
  }

  env.currentModel.simEnvironment.paramControls = [];

  let retire = env.simResults.simModel.findParameterByName("PrimaryRetireAge");
  let passing = env.simResults.simModel.findParameterByName("PrimaryLifeExpectancy");

  createControl(retire.baseID, retire.value, 20, 90);
  createControl(passing.baseID, passing.value, 20, 90);
}




export { AuthProvider, useAuth, useDispatcher }



function getLocalData() {
  let user_settings = {
    descFilter: '',
    showIncomes: true,
    showExpenses: true,
    showTransfers: true
  }

  let sim_env = {
    startDate: new Date(),

    paramControls: [],
    quickControls: [],
  }

  let obj = {
    userSettings: user_settings,
    session: null,
    currentModel: { model: null, simEnvironment: sim_env, lastSavedDate: "", lastUpdateDate: "" },
    simResults: null,
    baseline: null
  }



  let settings_data = getStorageItem("pcplanner-settings");
  if (settings_data !== null) {
    obj.userSettings = settings_data;
  }


  let session_data = getStorageItem("pcplanner-session");
  if (session_data !== null) {
    let now = new Date();
    let exp_date = new Date(session_data.expires);
  
    console.log('expires      : ' + session_data.expires);
    console.log('expires local: ' + exp_date.toLocaleString());
    console.log('expires ISO  : ' + exp_date.toISOString());
    console.log('expires UTC  : ' + exp_date.toUTCString());
  
    if (exp_date < now) {
      return obj;
    }

    obj.session = session_data;

    let model_data = getStorageItem("pcplanner-model");
    if (model_data !== null) {
      obj.currentModel = model_data;
    }
  }

  return obj;
}


/*
    userSettings: obj.userSettings,
    session: obj.session,
    currentModel: obj.currentModel
*/
function setLocalData(data) {
  if (typeof localStorage === 'undefined') {
    return;
  }
  localStorage.setItem("pcplanner-settings", JSON.stringify(data.userSettings));
  localStorage.setItem("pcplanner-session", JSON.stringify(data.session));
  localStorage.setItem("pcplanner-model", JSON.stringify(data.currentModel));
}


function getStorageItem(name) {
  if (typeof localStorage === 'undefined') {
    return null;
  }

  try {
    let data = localStorage.getItem(name);
    let obj = JSON.parse(data);

    return obj;
  }
  catch (err) {
    console.log("ERORR: " + err.message);
  }

  return null;
}